{
  "el": {
    "profile": {
      "actions": {
        "changeEmail": "Αλλαγή διεύθυνσης email",
        "changeEmailAddress": "Αλλαγή διεύθυνσης email",
        "delete": "Διαγραφή",
        "installApp": "Εγκατάσταση εφαρμογής 🚀",
        "launchApp": "Εκκίνηση εφαρμογής",
        "save": "Αποθήκευση",
        "showQRCode": "Εμφάνιση κωδικού QR"
      },
      "attributes": {
        "decimal_separator": "Δεκαδική σημειογραφία νομίσματος",
        "email_address": "Email",
        "email_address_new": "Νέα διεύθυνση email",
        "email_address_old": "Παλιά διεύθυνση email"
      },
      "labels": {
        "addToHomeScreen": "Προσθήκη στην αρχική οθόνη",
        "allowAccess": "Δώσε στη Ziggu πρόσβαση στον λογαριασμό σου",
        "allowImpersonation": "Επίτρεψε πρόσβαση στη Ziggu",
        "allowImpersonationSubtext": "Ίσως χρειαστεί να αποκτήσουμε προσωρινά πρόσβαση στον λογαριασμό σου για να διαγνώσουμε και να λύσουμε ένα θέμα υποστήριξης που έχεις αναφέρει. Η πρόσβασή μας λήγει αυτόματα μετά από 7 ημέρες.",
        "allowRecording": "Επίτρεψε καταγραφή συνεδρίας",
        "allowRecordingSubtext": "Η καταγραφή της συνεδρίας σου στη Ziggu μπορεί να μας βοηθήσει να βρούμε την αιτία ενός θέματος που έχεις αναφέρει. Η καταγραφή σταματά αυτόματα μετά από 60 λεπτά ή όποτε απενεργοποιήσεις αυτή τη ρύθμιση.",
        "and_x_other": "και 1 ακόμη | και {other_count} ακόμη",
        "bulk_invite_help": "Θα προσκαλέσουμε τις επιλεγμένες επαφές στην πλατφόρμα. Αυτό μπορεί να πάρει μερικά λεπτά.",
        "changeEmailAddress": "Αλλαγή διεύθυνσης email για {profile_name}",
        "checkYourInbox": "Σου στείλαμε ένα email στο {email_address} για επιβεβαίωση",
        "confirmEmailUpdate": "Το email περιέχει έναν σύνδεσμο για να ολοκληρώσεις τη διαδικασία ενημέρωσης. Επικοινώνησε μαζί μας αν αντιμετωπίσεις οποιοδήποτε πρόβλημα.",
        "confirmPasswordReset": "Στάλθηκε ένα email με σύνδεσμο επαναφοράς του κωδικού πρόσβασής σου. Έλεγξε τα εισερχόμενά σου. Επικοινώνησε μαζί μας αν αντιμετωπίσεις οποιοδήποτε πρόβλημα.",
        "currency": {
          "comma": "Κόμμα: 200.450,99",
          "point": "Τελεία: 200,450.99"
        },
        "emailAddressNewConfirm": "Επιβεβαίωση νέας διεύθυνσης email",
        "emailNotificationsInterval": "Συχνότητα email για νέες ειδοποιήσεις",
        "emailNotificationsIntervalSubtext": "Εδώ μπορείς να ορίσεις πόσο συχνά θέλεις η πλατφόρμα να ελέγχει αν υπάρχουν ενημερώσεις για σένα και να σου στέλνει email σχετικά.",
        "explainerSendEmail": "Ένα νέο email πρόσκλησης θα σταλεί σε {name}",
        "explainerUpdateEmailActive": "Το προφίλ {name} είναι ήδη ενεργό στην πλατφόρμα. Θα σταλεί ένα email στη νέα διεύθυνση email με σύνδεσμο για επιβεβαίωση της αλλαγής διεύθυνσης email.",
        "explainerUpdateEmailInvited": "{name} έχει ήδη προσκληθεί. Μια νέα πρόσκληση θα σταλεί στη νέα διεύθυνση email. Τυχόν προηγούμενες προσκλήσεις δεν θα λειτουργούν πλέον.",
        "followDevicePrompts": "Ακολούθησε τις οδηγίες της συσκευής σου για να προσθέσεις την εφαρμογή στην αρχική οθόνη",
        "impersonateProfile": "Υπόδυση {profile_name}",
        "important": "Σημαντικό",
        "importantContent": "Συνδέσου στην πλατφόρμα από το πρόγραμμα περιήγησης στην κινητή σου συσκευή πριν συνεχίσεις.",
        "installMobileApp": "Εγκατάσταση εφαρμογής για κινητά",
        "logInMobileDevice": "Σύνδεση στην κινητή σου συσκευή",
        "maintainerCannotImpersonatePartner": "Μόνο τα μέλη της ομάδας με ρόλο «Ιδιοκτήτης» μπορούν να κάνουν υπόδυση συνεργατών.",
        "maintainerCannotUpdateEmailAddress": "Μόνο τα μέλη της ομάδας με ρόλο «Ιδιοκτήτης» μπορούν να ενημερώσουν τη διεύθυνση email",
        "multipleProfiles": "Αυτός ο χρήστης έχει πολλαπλά προφίλ Ziggu. Μόνο ο ίδιος ο χρήστης μπορεί να αλλάξει τη διεύθυνση email.",
        "mustBeLoggedInBeforeQR": "Πρέπει να συνδεθείς στην κινητή σου συσκευή πριν σκανάρεις τον κωδικό QR",
        "noEmailAddressAdded": "Δεν έχει προστεθεί διεύθυνση email",
        "onceLoggedInScan": "Μόλις συνδεθείς, σκάναρε τον κωδικό QR για να εγκαταστήσεις την εφαρμογή στη συσκευή σου",
        "openMobileBrowser": "Άνοιξε το πρόγραμμα περιήγησης στο κινητό σου και επισκέψου",
        "public_api_access": "Token πρόσβασης δημόσιου API",
        "redirectAutomatically": "Θα ανακατευθυνθείς αυτόματα σε {seconds} δευτερόλεπτα",
        "requestPasswordReset": "Επαναφορά κωδικού πρόσβασης",
        "scanQRCode": "Σκανάρισμα κωδικού QR",
        "toLogInCredentials": "για να συνδεθείς με τα διαπιστευτήριά σου",
        "updateEmailFailed": "Η ενημέρωση της διεύθυνσης email απέτυχε. Δοκίμασε ξανά ή επικοινώνησε μαζί μας.",
        "updateEmailSuccessful": "Η διεύθυνση email ενημερώθηκε με επιτυχία",
        "updateFailed": "Η ενημέρωση απέτυχε. Δοκίμασε ξανά ή επικοινώνησε μαζί μας."
      },
      "notifications": {
        "avatarChangedSuccessfully": "Το άβαταρ ενημερώθηκε. Οι αλλαγές μπορεί να χρειαστούν έως και μία ώρα για να γίνουν ορατές."
      },
      "toasts": {
        "bulk_invite": "Ξεκινήσαμε να προσκαλούμε τις επιλεγμένες επαφές στην πλατφόρμα",
        "emailResendSuccessfully": "Το email εστάλη ξανά με επιτυχία"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "Η διεύθυνση email είτε δεν υπάρχει είτε δεν υπάρχει πλέον, άλλαξε τη διεύθυνση email.",
          "illegal_address": "Μη έγκυρη διεύθυνση email: η διεύθυνση email που δίνεις μπορεί να μην είναι σωστά διαμορφωμένη, έλεγξε ότι η διεύθυνση email έχει τη σωστή μορφή και δεν περιέχει μη επιτρεπτούς χαρακτήρες.",
          "isp_block": "Αποκλεισμός ISP: ένας αποκλεισμός συνήθως σημαίνει ότι η διεύθυνση IP ή ο διακομιστής μας απορρίφθηκε από τον διακομιστή αλληλογραφίας του παραλήπτη.",
          "soft_bounce": "Το άτομο απουσιάζει από το γραφείο, ή το γραμματοκιβώτιο είναι γεμάτο και δεν δέχεται email.",
          "spam_complaint": "Το άτομο πάτησε «Σήμανση ως ανεπιθύμητο» στο πρόγραμμα email του, και αυτή η διεύθυνση email έχει απενεργοποιηθεί. Αν ο παραλήπτης επικοινωνήσει μαζί σου και θέλει να λαμβάνει ξανά email, επικοινώνησε μαζί μας.",
          "spam_notification": "Τα email απορρίφθηκαν από τον διακομιστή αλληλογραφίας. Αυτό μπορεί να οφείλεται σε αυστηρές εταιρικές πολιτικές στον διακομιστή αλληλογραφίας του παραλήπτη ή σε μια ατυχή επιλογή λέξεων στο email σου που επισημαίνεται από φίλτρα ανεπιθύμητων μηνυμάτων."
        },
        "emailAddressBounced": "Σφάλμα διεύθυνσης email",
        "emailDoesntMatch": "Το email δεν ταιριάζει",
        "emailTaken": "Η διεύθυνση email χρησιμοποιείται ήδη. Αν θέλεις να κάνεις ούτως ή άλλως αυτή την αλλαγή, επικοινώνησε μαζί μας μέσω του chat.",
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "requireEmailAddress": "Το email είναι υποχρεωτικό",
        "tooManyRequests": "Επιτρέπεται μόνο μία αλλαγή διεύθυνσης email κάθε 5 λεπτά. Δοκίμασε ξανά αργότερα."
      }
    }
  }
}
